module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/buttons/skew-button/skew-button.component.scss
// module id = ./src/app/features/buttons/skew-button/skew-button.component.scss
// module chunks = main